var map = {
	"./Poppins-Regular.ttf": 2778,
	"./arrows.png": 4658,
	"./calendar.png": 3165,
	"./graph.png": 6477,
	"./graph2.png": 2971,
	"./inance.png": 7548,
	"./logo.png": 6949,
	"./logo/bitcoin.png": 5351,
	"./logo/bnb.png": 2398,
	"./logo/etherum.png": 8035,
	"./logo/litecoin.png": 8502,
	"./logo/usdt.png": 8140,
	"./maquette.png": 4675,
	"./menu/clients.png": 4842,
	"./menu/help.png": 83,
	"./menu/invoices.png": 4181,
	"./menu/logout.png": 1657,
	"./menu/messages.png": 9831,
	"./menu/products.png": 8498,
	"./menu/settings.png": 7989,
	"./notif.png": 8313,
	"./outline1.png": 2271,
	"./outline2.png": 5335,
	"./profil.png": 5236,
	"./search.png": 2305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;